var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2814-1387a17.883,17.883,0,0,1-12.728-5.272A17.882,17.882,0,0,1-2832-1405a17.882,17.882,0,0,1,5.272-12.728A17.883,17.883,0,0,1-2814-1423a17.882,17.882,0,0,1,12.728,5.272A17.883,17.883,0,0,1-2796-1405a17.883,17.883,0,0,1-5.272,12.728A17.882,17.882,0,0,1-2814-1387Zm-5-20a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h3v3a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1v-3h3a1,1,0,0,0,1-1v-2a1,1,0,0,0-1-1h-3v-3a1,1,0,0,0-1-1h-2a1,1,0,0,0-1,1v3Z",
    transform: "translate(2832 1423)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomAdd);
export default __webpack_public_path__ + "static/media/custom-add.70ab7e707a3ddf436eed0610d7874db1.svg";
export { ForwardRef as ReactComponent };